module.exports = __webpack_public_path__ + "img/2.cdd01dc9.jpg";